import styled from 'styled-components';

export const SmallCatContainer = styled.div`
  transform: scale(0.5);
  position: relative;
  top: -160px;
  left: -85px;
  margin-right: -160px;
  margin-bottom: -305px;
`;

export const MediumCatContainer = styled.div`
  transform: scale(0.75);
  position: relative;
  top: -75px;
  left: -45px;
  margin-right: -75px;
  margin-bottom: -150px;
`;
